import { Event } from '../types';

export function shouldAutoHideEvent(event: Event): boolean {
  const now = new Date();
  const eventDate = new Date(event.date);

  // Hide if event date is in the past (compare at day level, not time level)
  // Set both dates to midnight for fair comparison
  const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const eventMidnight = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());

  if (eventMidnight < todayMidnight) {
    return true;
  }

  // Hide if event is cancelled or expired
  if (event.status === 'cancelled' || event.status === 'expired') {
    return true;
  }

  // Hide if event is full (current applicants >= max applicants)
  // Only hide if maxApplicants is explicitly set (not null/undefined) and limit is reached
  if (
    event.maxApplicants != null &&
    event.maxApplicants > 0 &&
    event.currentApplicants != null &&
    event.currentApplicants >= event.maxApplicants
  ) {
    return true;
  }

  return false;
}

export function filterOutAutoHiddenEvents(events: Event[]): Event[] {
  return events.filter(event => !shouldAutoHideEvent(event));
}

/**
 * Filter for landing page: only show vybes with completed images
 * (prevents showing "Image on its way!" to non-logged-in visitors)
 */
export function filterLandingPageEvents(events: Event[]): Event[] {
  return events.filter(event => {
    // Hide if auto-hidden (past, cancelled, full)
    if (shouldAutoHideEvent(event)) return false;

    // Hide if image not ready (pending or generating)
    if (event.imageGenerationStatus === 'pending' || event.imageGenerationStatus === 'generating') {
      return false;
    }

    // Hide if no image URL at all
    if (!event.imageUrl && !event.image_url) {
      return false;
    }

    return true;
  });
}
